module.exports = __webpack_public_path__ + "media/images/shopping-bag-ac9379c597ae7f8947d7382cb985fb7a.svg";